import { render, staticRenderFns } from "./ListTreatmentSessions.vue?vue&type=template&id=bfae3f58"
import script from "./ListTreatmentSessions.vue?vue&type=script&lang=js"
export * from "./ListTreatmentSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports